// eslint-disable-next-line no-shadow
export enum AuthenticationStatus {
	LOADING = 'loading',
	AUTHENTICATED = 'authenticated',
	UNAUTHENTICATED = 'unauthenticated',
	UNKNOWN = 'unknown',
}
